import React from "react"
import Grid from "@mui/material/Grid"
import { CloudinaryImage } from "@cloudinary/url-gen"
import { AdvancedImage } from "@cloudinary/react"
import { fill } from "@cloudinary/url-gen/actions/resize"
import { lazyLoadPreset } from "../../../utils/cloudinaryImageUtils"

const getImage = (imageId, width, alt, style, folder = "misc-images") => (
  <AdvancedImage
    cldImg={new CloudinaryImage(`${folder}/${imageId}`, {
      cloudName: "coastline-academy",
    })
      .resize(fill(width))
      .quality(80)
      .format("auto")}
    alt={alt}
    style={style}
    plugins={[lazyLoadPreset]}
  />
)

const TrustBadges = () => (
  <Grid
    container
    spacing={0}
    alignItems="center"
    style={{ textAlign: "center" }}
  >
    <Grid item xs={4}>
      {getImage("credit-cards_sjk47f", 240, "Powered by Stripe", {
        width: "100%",
        maxWidth: 240,
        position: "inherit",
        left: "unset",
        marginLeft: "unset",
      })}
    </Grid>
    <Grid item xs={4}>
      {getImage("guarantee_yorwsn", 80, "Money Back Guarantee", {
        width: "50%",
        maxWidth: 80,
        position: "inherit",
        left: "unset",
        marginLeft: "unset",
      })}
    </Grid>
    <Grid item xs={4}>
      {getImage("secure-ssl_d7imqj", 124, "SSL Encryption", {
        width: "100%",
        maxWidth: 124,
        position: "inherit",
        left: "unset",
        marginLeft: "unset",
      })}
    </Grid>
    <Grid item xs={4}>
      {getImage("affirm-logo_q3gut7", 124, "Affirm Financing", {
        width: "100%",
        maxWidth: 124,
        position: "inherit",
        left: "unset",
        marginLeft: "unset",
      })}
    </Grid>
    <Grid item xs={4}>
      {getImage("klarna-logo_dmqf35", 200, "Klarna Financing", {
        width: "100%",
        maxWidth: 200,
        position: "inherit",
        left: "unset",
        marginLeft: "unset",
      })}
    </Grid>
    <Grid item xs={4}>
      {getImage("afterpay-logo_wgbla2", 200, "Afterpay Financing", {
        width: "100%",
        maxWidth: 200,
        position: "inherit",
        left: "unset",
        marginLeft: "unset",
      })}
    </Grid>
    <Grid item xs={4}>
      {getImage(
        "bbb-a-plus",
        155,
        "Better Business Bureau A+ Rating",
        {
          width: "100%",
          maxWidth: 155,
          position: "inherit",
          left: "unset",
          marginLeft: "unset",
        },
        "logos",
      )}
    </Grid>
  </Grid>
)

export default TrustBadges
